/* eslint-disable max-lines */
/* eslint-disable complexity */
// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes, { func, string } from 'prop-types';
import { compose } from 'redux';
import { updatePageData } from '@tcp/core/src/analytics/actions';
import { connect } from 'react-redux';
import { toggleApplyNowModal } from '@tcp/core/src/components/common/molecules/ApplyNowPLCCModal/container/ApplyNowModal.actions';
import { toastMessageInfo } from '@tcp/core/src/components/common/atoms/Toast/container/Toast.actions';
import SpcSelector from '@tcp/core/src/components/features/CnC/SinglePageCheckout/container/SinglePageCheckout.selector';
import {
  getCurrentPerkLevel,
  getUserId,
  getUserLoggedInState,
  isRememberedUser,
} from '@tcp/core/src/components/features/account/User/container/User.selectors';
import withDynamicSaga from '@tcp/core/src/components/common/hoc/withDynamicSaga';
import withDynamicReducer from '@tcp/core/src/components/common/hoc/withDynamicReducer';
import {
  getLedgerSummaryData,
  getOrderItems,
} from '@tcp/core/src/components/features/CnC/common/organism/OrderLedger/container/orderLedger.selector';
import {
  getTCPLicensedProductBrand,
  getProductOfferPrice,
} from '@tcp/core/src/components/features/CnC/CartItemTile/container/CartItemTile.selectors.js';
import CouponReducer from '@tcp/core/src/components/features/CnC/common/organism/CouponAndPromos/container/Coupon.reducer';
import CouponSaga from '@tcp/core/src/components/features/CnC/common/organism/CouponAndPromos/container/Coupon.saga';
import {
  applyCoupon,
  removeCoupon,
  setError,
  toggleNeedHelpModalState,
  getCouponTermsAndConditions,
  getCouponList,
  setAppliedCOuponStatus,
  fromCouponTab,
  setBonusPointDayCouponIndex,
  fromIsApply,
  setCouponCode,
  applyPlaceBucksCoupons,
  setMultiAddSuccess,
  setMultiAddCouponError,
} from './Coupon.actions';
import {
  getCouponFetchingState,
  getAppliedCouponListState,
  getAvailableCouponListState,
  getonHoldOrAppliedCouponListState,
  getNeedHelpContent,
  getPlaceCashContent,
  getAllCoupons,
  getNeedHelpModalState,
  getAppliedExpiredCouponListState,
  getonHoldCouponListState,
  getErrorFromCouponTextBox,
  getAppliedCouponSuccess,
  getBonusPointsDay,
  getCallCouponAction,
  getFromCouponTab,
  getFromApplyCTA,
  getCouponCode,
  getMultiAddCouponLoaderState,
  getMultiAddCouponSucessState,
  getMultiAddCouponErrorState,
} from './Coupon.selectors';
import {
  getCMSEnabledMultiUseCouponList,
  getAutoApplyPerkCouponType,
  getcouponSectionNewDesign,
  getcouponOnHoldNewDesign,
  getIsBonusPointDayEnabled,
  getIsCouponSmoothScrollEnabled,
  getMPRandCSHCouponRedesign,
  getNewCouponUXWithoutTabKillSwitch,
  getIsSiteWidePromoAbTestEnabled,
  getIsNewCouponPlacementEnable,
  getIsApplyMultipleCoupons,
  getIsCSHEnabled,
  getIsLoyaltyTieringEnabled,
  getIsBrandExclusionMessageEnabled,
  getIsLicensedProductTotal,
} from '../../../../../../../reduxStore/selectors/session.selectors';
import Coupon from '../views/Coupon.view';
import MyOffersCoupons from '../../../../../account/common/organism/MyOffersCoupons/views/MyOffersCoupons.view';
import BagPageSelectors from '../../../../BagPage/container/BagPage.selectors';
import BAG_PAGE_ACTIONS from '../../../../BagPage/container/BagPage.actions';
import { isBagRoute } from '../../../../../../../utils';

const getContentLabels = (needHelpRichText, placeCashContent) => {
  return {
    NEED_HELP_RICH_TEXT: needHelpRichText,
    PLACE_CASH_CONTENT: placeCashContent,
  };
};
export class CouponContainer extends React.PureComponent {
  componentDidMount() {
    const { fetchCoupons = () => {}, callCouponAction, appliedCoupons } = this.props;
    if (!callCouponAction && appliedCoupons && Object.keys(appliedCoupons).length > 0) {
      fetchCoupons(appliedCoupons);
    }
  }

  getPageDataObject = () => {
    const { pageName, pageSection } = this.props;
    return {
      pageName: `${pageName}:${pageSection}`,
      pageSection: pageName,
      pageSubSection: pageName,
      pageType: pageName,
      pageShortName: `${pageName}:${pageSection}`,
    };
  };

  calculateLicensedProductTotal = () => {
    const { cartOrderItems, isLicensedProductTotal } = this.props;
    let total = 0;
    if (cartOrderItems?.size > 0 && isLicensedProductTotal) {
      cartOrderItems.forEach((item) => {
        if (getTCPLicensedProductBrand(item)) {
          total += getProductOfferPrice(item);
        }
      });
    }
    return total;
  };

  render() {
    const {
      handleApplyCoupon,
      handleApplyCouponFromList,
      handleRemoveCoupon,
      appliedCouponList,
      availableCouponList,
      allCouponList,
      needHelpRichText,
      placeCashContent,
      handleErrorCoupon,
      isCheckoutFlow,
      showAccordian,
      isCarouselView,
      closedOverlay,
      idPrefix,
      additionalClassNameModal,
      openApplyNowModal,
      navigation,
      bagLoading,
      isNeedHelpModalOpen,
      toggleNeedHelpModal,
      isFetchingCouponState,
      measurePositionHandler,
      needHelpContentId,
      fetchNeedHelpContent,
      toastMessage,
      placeCashContentId,
      currentUserId,
      setMaxItemErrorDisplayedAction,
      appliedExpiredCoupon,
      showMaxItemErrorDisplayed,
      showCouponMergeError,
      onHoldCouponList,
      spc,
      showMoreModal,
      orderEstimatedTotal,
      spcBag,
      couponTextBoxError,
      couponSelfHelp,
      fetchCouponTermsAndConditions,
      isFromCheckoutPage,
      isNonCacheBagLoading,
      isAccountDrawer,
      multiUseCouponList,
      isUserLoggedIn,
      isAccountDashboard,
      isPlacePerks,
      isPlacePerkEnabled,
      autoApplyPerkCouponType,
      fromPaymentModal,
      afterpayCouponsInfo,
      couponSectionNewDesign,
      appliesCouponSuccess,
      setAppliedCOuponStatusAction,
      isSPC,
      isWallet,
      onHoldOrAppliedCouponListState,
      couponOnHoldNewDesign,
      bonusPointDayData,
      fromPlaceRewards,
      isBonusPointDayEnabled,
      variation,
      isCouponSmoothScrollEnabled,
      currentPerkLevel,
      displayCards,
      isMPRAndCSHCouponRedesignEnabled,
      isFromMPRPage,
      fromCouponTabAction,
      fromCouponTabState,
      setBonusPointDayCouponIndexAction,
      fromBagPage,
      fromApplyCTA,
      fromIsApplyAction,
      rememberedUserFlag,
      ledgerSummaryData,
      isNewCouponUXWithoutTabEnabled,
      formCouponCode,
      setCouponCodeAction,
      fromSinglePageCheckoutComponent,
      isSiteWidePromoAbtestEnabled,
      isNewCouponPositionEnabled,
      applyPlaceBucksCouponsAction,
      isApplyMultipleCouponsEnabled,
      multiAddCouponLoader,
      multiAddCouponSuccess,
      setMultiAddCpnSuccessAction,
      multiAddCouponErrorState,
      resetCouponError,
      isCSHEnabled,
      isLoyaltyTieringEnabled,
      isNewAccountDrawer,
    } = this.props;
    // isCarouselView flag is only passed when coupon component is included from account
    const isFetching = isFetchingCouponState || (!isCarouselView && bagLoading);
    const contentLabels = getContentLabels(needHelpRichText, placeCashContent);
    const appliedCoupon = couponOnHoldNewDesign
      ? onHoldOrAppliedCouponListState
      : appliedCouponList;
    const reversedAppliedList = couponSectionNewDesign
      ? appliedCoupon && appliedCoupon?.reverse()
      : appliedCouponList;
    const totalPriceOfAllLicensedProducts = this.calculateLicensedProductTotal();
    return (
      <>
        {!isCarouselView && (
          <Coupon
            contentLabels={contentLabels}
            isCheckout={isCheckoutFlow}
            isFetching={isFetching}
            handleApplyCoupon={handleApplyCoupon}
            handleApplyCouponFromList={handleApplyCouponFromList}
            handleRemoveCoupon={handleRemoveCoupon}
            appliedCouponList={reversedAppliedList}
            couponOnHoldNewDesign={couponOnHoldNewDesign}
            availableCouponList={fromPaymentModal ? allCouponList : availableCouponList}
            handleErrorCoupon={handleErrorCoupon}
            showAccordian={showAccordian}
            additionalClassNameModal={additionalClassNameModal}
            idPrefix={idPrefix}
            bagLoading={bagLoading}
            resetCouponError={resetCouponError}
            openApplyNowModal={openApplyNowModal}
            navigation={navigation}
            isNeedHelpModalOpen={isNeedHelpModalOpen}
            toggleNeedHelpModal={toggleNeedHelpModal}
            toastMessage={toastMessage}
            measurePositionHandler={measurePositionHandler}
            needHelpContentId={needHelpContentId}
            fetchNeedHelpContent={fetchNeedHelpContent}
            showExpiredMessage
            placeCashContentId={placeCashContentId}
            currentUserId={currentUserId}
            showMaxItemErrorDisplayed={showMaxItemErrorDisplayed}
            setMaxItemErrorDisplayedAction={setMaxItemErrorDisplayedAction}
            appliedExpiredCoupon={appliedExpiredCoupon}
            showCouponMergeError={showCouponMergeError}
            onHoldCouponList={onHoldCouponList}
            spc={spc}
            spcBag={spcBag}
            isNonCacheBagLoading={isNonCacheBagLoading}
            showMoreModal={showMoreModal}
            orderEstimatedTotal={orderEstimatedTotal}
            couponTextBoxError={couponTextBoxError}
            fetchCouponTermsAndConditions={fetchCouponTermsAndConditions}
            isFromCheckoutPage={isFromCheckoutPage}
            multiUseCouponList={multiUseCouponList}
            fromPaymentModal={fromPaymentModal}
            afterpayCouponsInfo={afterpayCouponsInfo}
            couponSectionNewDesign={couponSectionNewDesign}
            appliesCouponSuccess={appliesCouponSuccess}
            setAppliedCOuponStatusAction={setAppliedCOuponStatusAction}
            isSPC={isSPC}
            bonusPointDayData={bonusPointDayData}
            fromPlaceRewards={fromPlaceRewards}
            isBonusPointDayEnabled={isBonusPointDayEnabled}
            variation={variation}
            isCouponSmoothScrollEnabled={isCouponSmoothScrollEnabled}
            currentPerkLevel={currentPerkLevel}
            displayCards={displayCards}
            fromCouponTabAction={fromCouponTabAction}
            fromCouponTabState={fromCouponTabState}
            setBonusPointDayCouponIndexAction={setBonusPointDayCouponIndexAction}
            fromBagPage={fromBagPage}
            fromApplyCTA={fromApplyCTA}
            fromIsApplyAction={fromIsApplyAction}
            rememberedUserFlag={rememberedUserFlag}
            ledgerSummaryData={ledgerSummaryData}
            allCouponList={allCouponList}
            isNewCouponUXWithoutTabEnabled={isNewCouponUXWithoutTabEnabled}
            setCouponCodeAction={setCouponCodeAction}
            formCouponCode={formCouponCode}
            fromSinglePageCheckoutComponent={fromSinglePageCheckoutComponent}
            isSiteWidePromoAbtestEnabled={isSiteWidePromoAbtestEnabled}
            isNewCouponPositionEnabled={isNewCouponPositionEnabled}
            applyPlaceBucksCouponsAction={applyPlaceBucksCouponsAction}
            isApplyMultipleCouponsEnabled={isApplyMultipleCouponsEnabled}
            multiAddCouponLoader={multiAddCouponLoader}
            multiAddCouponSuccess={multiAddCouponSuccess}
            setMultiAddCpnSuccessAction={setMultiAddCpnSuccessAction}
            multiAddCouponErrorState={multiAddCouponErrorState}
            isCSHEnabled={isCSHEnabled}
            isLoyaltyTieringEnabled={isLoyaltyTieringEnabled}
            totalPriceOfAllLicensedProducts={totalPriceOfAllLicensedProducts}
          />
        )}

        {isCarouselView && (
          <MyOffersCoupons
            labels={contentLabels}
            isCheckout={isCheckoutFlow}
            isFetching={isFetching}
            handleApplyCoupon={handleApplyCoupon}
            handleApplyCouponFromList={handleApplyCouponFromList}
            handleRemoveCoupon={handleRemoveCoupon}
            allCouponList={allCouponList}
            handleErrorCoupon={handleErrorCoupon}
            showAccordian={showAccordian}
            sliceCount={10}
            additionalClassNameModal={additionalClassNameModal}
            isCarouselView={isCarouselView}
            closedOverlay={closedOverlay}
            toastMessage={toastMessage}
            isNeedHelpModalOpen={isNeedHelpModalOpen}
            toggleNeedHelpModal={toggleNeedHelpModal}
            spc={spc}
            spcBag={spcBag}
            showMoreModal={showMoreModal}
            couponSelfHelp={couponSelfHelp}
            fetchCouponTermsAndConditions={fetchCouponTermsAndConditions}
            isAccountDrawer={isAccountDrawer}
            multiUseCouponList={multiUseCouponList}
            isUserLoggedIn={isUserLoggedIn}
            isAccountDashboard={isAccountDashboard}
            isPlacePerks={isPlacePerks}
            isPlacePerkEnabled={isPlacePerkEnabled}
            autoApplyPerkCouponType={autoApplyPerkCouponType}
            couponSectionNewDesign={couponSectionNewDesign}
            couponOnHoldNewDesign={couponOnHoldNewDesign}
            appliesCouponSuccess={appliesCouponSuccess}
            setAppliedCOuponStatusAction={setAppliedCOuponStatusAction}
            isSPC={isSPC}
            isWallet={isWallet}
            bonusPointDayData={bonusPointDayData}
            fromPlaceRewards={fromPlaceRewards}
            isBonusPointDayEnabled={isBonusPointDayEnabled}
            variation={variation}
            isCouponSmoothScrollEnabled={isCouponSmoothScrollEnabled}
            currentPerkLevel={currentPerkLevel}
            displayCards={displayCards}
            isMPRAndCSHCouponRedesignEnabled={isMPRAndCSHCouponRedesignEnabled}
            isFromMPRPage={isFromMPRPage}
            fromCouponTabAction={fromCouponTabAction}
            fromCouponTabState={fromCouponTabState}
            setBonusPointDayCouponIndexAction={setBonusPointDayCouponIndexAction}
            fromBagPage={fromBagPage}
            fromApplyCTA={fromApplyCTA}
            fromIsApplyAction={fromIsApplyAction}
            rememberedUserFlag={rememberedUserFlag}
            ledgerSummaryData={ledgerSummaryData}
            isNewCouponUXWithoutTabEnabled={isNewCouponUXWithoutTabEnabled}
            setCouponCodeAction={setCouponCodeAction}
            formCouponCode={formCouponCode}
            isSiteWidePromoAbtestEnabled={isSiteWidePromoAbtestEnabled}
            isNewCouponPositionEnabled={isNewCouponPositionEnabled}
            totalPriceOfAllLicensedProducts={totalPriceOfAllLicensedProducts}
            isLoyaltyTieringEnabled={isLoyaltyTieringEnabled}
            isNewAccountDrawer={isNewAccountDrawer}
          />
        )}
      </>
    );
  }
}

CouponContainer.propTypes = {
  isFetchingCouponState: PropTypes.bool.isRequired,
  bagLoading: PropTypes.bool.isRequired,
  isCheckoutFlow: PropTypes.bool.isRequired,
  handleApplyCoupon: PropTypes.func.isRequired,
  handleApplyCouponFromList: PropTypes.func.isRequired,
  handleRemoveCoupon: PropTypes.func.isRequired,
  appliedCouponList: PropTypes.shape({}).isRequired,
  availableCouponList: PropTypes.shape({}).isRequired,
  showAccordian: PropTypes.bool.isRequired,
  additionalClassNameModal: PropTypes.string.isRequired,
  allCouponList: PropTypes.shape([]).isRequired,
  needHelpRichText: PropTypes.string.isRequired,
  placeCashContent: PropTypes.string.isRequired,
  handleErrorCoupon: PropTypes.func.isRequired,
  isCarouselView: PropTypes.bool,
  closedOverlay: PropTypes.func,
  idPrefix: PropTypes.string,
  openApplyNowModal: PropTypes.func,
  navigation: PropTypes.shape({}),
  pageName: PropTypes.string,
  pageSection: PropTypes.string,
  currentUserId: string.isRequired,
  isNeedHelpModalOpen: PropTypes.bool,
  toggleNeedHelpModal: PropTypes.func.isRequired,
  updateCouponPageData: PropTypes.func,
  toastMessage: PropTypes.func,
  measurePositionHandler: PropTypes.func,
  setMaxItemErrorDisplayedAction: func.isRequired,
  fetchNeedHelpContent: PropTypes.func.isRequired,
  needHelpContentId: PropTypes.shape({}).isRequired,
  placeCashContentId: PropTypes.shape({}).isRequired,
  appliedExpiredCoupon: PropTypes.shape({}),
  showMaxItemErrorDisplayed: PropTypes.bool.isRequired,
  showCouponMergeError: PropTypes.bool,
  onHoldCouponList: PropTypes.shape([]),
  spc: PropTypes.bool,
  spcBag: PropTypes.bool,
  orderEstimatedTotal: PropTypes.string,
  showMoreModal: PropTypes.bool,
  couponTextBoxError: PropTypes.shape({}),
  couponSelfHelp: PropTypes.bool,
  fetchCouponTermsAndConditions: PropTypes.func.isRequired,
  fetchCoupons: PropTypes.func,
  isAccountDrawer: PropTypes.bool,
  isUserLoggedIn: PropTypes.bool,
  isAccountDashboard: PropTypes.bool,
  isPlacePerks: PropTypes.bool,
  isPlacePerkEnabled: PropTypes.bool,
  autoApplyPerkCouponType: PropTypes.string,
  couponSectionNewDesign: PropTypes.bool,
  isBrandExclusionMessageEnabled: PropTypes.bool,
  cartOrderItems: PropTypes.shape([]),
  isNewAccountDrawer: PropTypes.bool,
};

CouponContainer.defaultProps = {
  closedOverlay: () => {},
  isCarouselView: false,
  idPrefix: '',
  navigation: null,
  openApplyNowModal: () => {},
  pageName: '',
  pageSection: '',
  isNeedHelpModalOpen: false,
  updateCouponPageData: () => {},
  measurePositionHandler: () => {},
  toastMessage: () => {},
  appliedExpiredCoupon: [],
  showCouponMergeError: false,
  onHoldCouponList: [],
  spc: false,
  spcBag: false,
  orderEstimatedTotal: '',
  showMoreModal: false,
  couponTextBoxError: '',
  couponSelfHelp: false,
  fetchCoupons: () => {},
  isAccountDrawer: false,
  isUserLoggedIn: false,
  isAccountDashboard: false,
  isPlacePerks: false,
  isPlacePerkEnabled: false,
  autoApplyPerkCouponType: '',
  couponSectionNewDesign: false,
  isBrandExclusionMessageEnabled: false,
  cartOrderItems: [],
  isNewAccountDrawer: false,
};

export const mapDispatchToProps = (
  dispatch,
  { fullPageInfo, isCheckoutFlow, fromCartPage, fromBagPage, isAccountDrawer }
) => ({
  fetchNeedHelpContent: (contentIds) => {
    dispatch(BAG_PAGE_ACTIONS.fetchModuleX(contentIds));
  },
  handleApplyCouponFromList: ({ coupon }) => {
    return new Promise((resolve, reject) => {
      dispatch(
        applyCoupon({
          fullPageInfo,
          isCheckoutFlow,
          formData: { couponCode: coupon.id },
          formPromise: { resolve, reject },
          coupon,
          fromCartPage,
          fromBagPage: fromBagPage || (isAccountDrawer && isBagRoute()),
        })
      );
    });
  },
  handleRemoveCoupon: ({ coupon }) => {
    return new Promise((resolve, reject) => {
      dispatch(
        removeCoupon({
          coupon,
          fullPageInfo,
          isCheckoutFlow,
          formPromise: { resolve, reject },
          analyticsCustomData: {
            eventName: 'walletlinksclickevent',
            pageNavigationText: 'my account-my wallet-remove from bag',
          },
          fromCartPage,
        })
      );
    });
  },
  handleApplyCoupon: (formData, _, props) =>
    new Promise((resolve, reject) => {
      dispatch(
        applyCoupon({
          formData,
          fullPageInfo,
          isCheckoutFlow,
          source: props && props.source,
          coupon: formData?.couponCode || '',
          formPromise: { resolve, reject },
          fromCartPage,
          fromInput: true,
          fromBagPage,
        })
      );
    }),
  handleErrorCoupon: (coupon) => {
    const timer = setTimeout(() => {
      dispatch(setError({ msg: null, couponCode: coupon.id }));
      clearTimeout(timer);
    }, 5000);
  },
  openApplyNowModal: (payload) => {
    dispatch(toggleApplyNowModal(payload));
  },
  resetCouponError: (payload) => {
    dispatch(setMultiAddCouponError(payload));
  },
  toastMessage: (payload) => {
    dispatch(toastMessageInfo(payload));
  },
  toggleNeedHelpModal: () => {
    dispatch(toggleNeedHelpModalState());
  },
  setMaxItemErrorDisplayedAction: (payload) => {
    dispatch(BAG_PAGE_ACTIONS.setMaxItemErrorDisplayed(payload));
  },
  updateCouponPageData: (payload) => {
    dispatch(updatePageData(payload));
  },
  fetchCouponTermsAndConditions: (coupon) => {
    dispatch(getCouponTermsAndConditions(coupon));
  },
  fetchCoupons: (appliedCoupons) => {
    dispatch(getCouponList({ appliedCoupons }));
  },
  setAppliedCOuponStatusAction: (payload) => {
    dispatch(setAppliedCOuponStatus(payload));
  },
  fromCouponTabAction: (payload) => {
    dispatch(fromCouponTab(payload));
  },
  setBonusPointDayCouponIndexAction: (payload) => {
    dispatch(setBonusPointDayCouponIndex(payload));
  },
  fromIsApplyAction: (payload) => {
    dispatch(fromIsApply(payload));
  },
  setCouponCodeAction: (payload) => {
    dispatch(setCouponCode(payload));
  },
  applyPlaceBucksCouponsAction: (payload) => {
    dispatch(applyPlaceBucksCoupons(payload));
  },
  setMultiAddCpnSuccessAction: (payload) => {
    dispatch(setMultiAddSuccess(payload));
  },
});

export const mapStateToProps = (state) => ({
  isFetchingCouponState: getCouponFetchingState(state),
  appliedCouponList: getAppliedCouponListState(state),
  availableCouponList: getAvailableCouponListState(state),
  onHoldOrAppliedCouponListState: getonHoldOrAppliedCouponListState(state),
  allCouponList: getAllCoupons(state),
  needHelpRichText: getNeedHelpContent(state),
  placeCashContent: getPlaceCashContent(state),
  isNeedHelpModalOpen: getNeedHelpModalState(state),
  bagLoading: BagPageSelectors.isBagLoading(state),
  isNonCacheBagLoading: BagPageSelectors.isNonCacheBagLoading(state),
  needHelpContentId: BagPageSelectors.getNeedHelpContent(),
  placeCashContentId: BagPageSelectors.getPlaceCashContent(),
  currentUserId: getUserId(state),
  showMaxItemErrorDisplayed: BagPageSelectors.getShowMaxItemErrorDisplayed(state),
  appliedExpiredCoupon: getAppliedExpiredCouponListState(state),
  showCouponMergeError: BagPageSelectors.getShowCouponMergeError(state),
  onHoldCouponList: getonHoldCouponListState(state),
  couponTextBoxError: getErrorFromCouponTextBox(state),
  multiUseCouponList: getCMSEnabledMultiUseCouponList(state),
  isUserLoggedIn: getUserLoggedInState(state),
  autoApplyPerkCouponType: getAutoApplyPerkCouponType(state),
  couponSectionNewDesign: getcouponSectionNewDesign(state),
  appliesCouponSuccess: getAppliedCouponSuccess(state),
  isSPC: SpcSelector.checkIsSinglePageCheckout(state),
  couponOnHoldNewDesign: getcouponOnHoldNewDesign(state),
  bonusPointDayData: getBonusPointsDay(state),
  isBonusPointDayEnabled: getIsBonusPointDayEnabled(state),
  isCouponSmoothScrollEnabled: getIsCouponSmoothScrollEnabled(state),
  currentPerkLevel: getCurrentPerkLevel(state),
  callCouponAction: getCallCouponAction(state),
  isMPRAndCSHCouponRedesignEnabled: getMPRandCSHCouponRedesign(state),
  fromCouponTabState: getFromCouponTab(state),
  fromApplyCTA: getFromApplyCTA(state),
  rememberedUserFlag: isRememberedUser(state),
  ledgerSummaryData: getLedgerSummaryData(state),
  isNewCouponUXWithoutTabEnabled: getNewCouponUXWithoutTabKillSwitch(state),
  formCouponCode: getCouponCode(state),
  isSiteWidePromoAbtestEnabled: getIsSiteWidePromoAbTestEnabled(state),
  isNewCouponPositionEnabled: getIsNewCouponPlacementEnable(state),
  appliedCoupons: BagPageSelectors.getCouponMap(state),
  isApplyMultipleCouponsEnabled: getIsApplyMultipleCoupons(state),
  multiAddCouponLoader: getMultiAddCouponLoaderState(state),
  multiAddCouponSuccess: getMultiAddCouponSucessState(state),
  multiAddCouponErrorState: getMultiAddCouponErrorState(state),
  isCSHEnabled: getIsCSHEnabled(state),
  isLoyaltyTieringEnabled: getIsLoyaltyTieringEnabled(state),
  cartOrderItems: getOrderItems(state),
  isBrandExclusionMessageEnabled: getIsBrandExclusionMessageEnabled(state),
  isLicensedProductTotal: getIsLicensedProductTotal(state),
});

const withReducer = withDynamicReducer({ key: 'CouponsAndPromos', reducer: CouponReducer });
const withSaga = withDynamicSaga({ key: 'CouponSaga', saga: CouponSaga });
const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withReducer, withSaga, withConnect)(CouponContainer);
